export default function MenuIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="24"
			height="6"
			viewBox="0 0 24 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="3" cy="3" r="2.5" fill="currentColor" />
			<circle cx="12" cy="3" r="2.5" fill="currentColor" />
			<circle cx="21" cy="3" r="2.5" fill="currentColor" />
		</svg>
	);
}
